import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./auth/AuthContext";
import { Layout } from "./components/Layout";
import { LoginPage } from "./pages/LoginPage";
import { DashboardPage } from "./pages/DashboardPage";
import { UsersPage } from "./pages/UsersPage";
import { CreateUserPage } from "./pages/CreateUserPage";
import { ExportUsersPage } from "./pages/ExportUsersPage";
import { ImportSubscriptionCsvPage } from "./pages/ImportSubscriptionCsvPage";
import { CostSummaryPage } from "./pages/CostSummaryPage";
import { ConfigPage } from "./pages/ConfigPage";
import { AuditLogPage } from "./pages/AuditLogPage";
import { FleetCreatePage } from "./pages/fleet/FleetCreatePage";
import { FleetListPage } from "./pages/fleet/FleetListPage";
import { FleetDetailPage } from "./pages/fleet/FleetDetailPage";
import { FleetStatsPage } from "./pages/fleet/FleetStatsPage";
import { FleetSubscriptionSyncPage } from "./pages/fleet/FleetSubscriptionSyncPage";

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { loading, isAuthenticated } = useAuth();
  if (loading) return <div className="main">加载中...</div>;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/*"
        element={
          <RequireAuth>
            <Layout>
              <Routes>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/users" element={<UsersPage />} />
                <Route path="/users/create" element={<CreateUserPage />} />
                <Route path="/users/export" element={<ExportUsersPage />} />
                <Route path="/subscriptions/import" element={<ImportSubscriptionCsvPage />} />
                <Route path="/cost-summary" element={<CostSummaryPage />} />
                <Route path="/config" element={<ConfigPage />} />
                <Route path="/audit-log" element={<AuditLogPage />} />
                <Route path="/fleet/create" element={<FleetCreatePage />} />
                <Route path="/fleet/instances" element={<FleetListPage />} />
                <Route path="/fleet/instances/:instanceId" element={<FleetDetailPage />} />
                <Route path="/fleet/stats" element={<FleetStatsPage />} />
                <Route path="/fleet/sync-subscription" element={<FleetSubscriptionSyncPage />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </Layout>
          </RequireAuth>
        }
      />
    </Routes>
  );
}
